import React, { Component } from 'react';
import { reduxForm, Field, formValueSelector, change } from 'redux-form'; import { connect } from 'react-redux';
import { Divider } from 'material-ui';
import { renderAutoCompleteSingleSelect, renderCheckBox } from '../../../../components/reduxFields';
import { CommonButton } from '../../../../components/buttons';
import { getMasterData,SaveDefaultTargetSettingsData,getDefaultTargetSettingsData } from './actions/defaultSettingsActions';
import { delay } from 'lodash';
const validate = (values) => {
    const errors = {};

    return errors;
};


class DefaultSettings extends Component {
    constructor(props) {
        super(props);
        this.state={
            disableStatus : false,
        }
    }

    componentDidMount() {
        let masterData = { 'masterdata': 'TARGETSTATUSWITHOUTREADY' };
        this.props.getMasterData(masterData);
        this.props.getDefaultTargetSettingsData(); 
    }
    
   componentDidUpdate(prevProps) {
    const prevData = prevProps.default_settings_data;
    const currentData = this.props.default_settings_data;

    if (
        currentData &&
        (!prevData ||
         prevData.isDefaultTargetActive !== currentData.isDefaultTargetActive ||
         prevData.statusId !== currentData.statusId)
    ) {
        this.props.dispatch(change('DefaultSettingsForm', 'isDefaultTargetActive', currentData.isDefaultTargetActive));
        this.setState({ disableStatus: !currentData.isDefaultTargetActive });

        if (currentData.isDefaultTargetActive) {
            this.props.dispatch(change('DefaultSettingsForm', 'statusId', currentData.statusId));
        } else {
            this.props.dispatch(change('DefaultSettingsForm', 'statusId', null));
        }
    }
}

   handleCheckBox=(e)=>{
       if(!e.currentTarget.checked){
          this.props.dispatch(change('DefaultSettingsForm', 'statusId', null));
       }
       this.setState({disableStatus:!e.currentTarget.checked})
   
   }

    onSubmitHandler(formData){
       this.props.SaveDefaultTargetSettingsData(formData);
       delay(()=>this.props.getDefaultTargetSettingsData(),300)  
    }
    handleStatusChange = (input , selected)=>{
      input.onChange(selected.value)
    }

    render() {
        const { handleSubmit } = this.props;
        return (
            <div>
                <form className="readmin-form custom_form" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))} >
                    <div className='mt-35 px-3'>
                        <h5>Default Target Settings</h5>
                    </div>

                    {<div className="mt-10" style={{ display: 'flex', alignItems: 'flex-start' }}>
                        {/* Left side: Active */}
                        <div className="col-sm-6" style={{ display: 'flex', alignItems: 'flex-start', justifyContent:"flex-start" }}>
                            
                                <div style={{width: "57%"}}>Active</div>
                                <Field
                                    name="isDefaultTargetActive"
                                    className='pl-4'
                                    style={{justifySelf:"center"}}
                                    component={renderCheckBox}
                                    onChange={(e)=>this.handleCheckBox(e)}
                                />
                        </div>

                        {/* Right side: Status */}
                        <div className="col-sm-6" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}>
                            <div style={{ display: 'flex', alignItems: 'center', width: '100%',justifyContent:"space-between" }}>
                                <span style={{ flex: '0 0 auto', marginRight: '150px', marginBottom: 'auto' }}>Status</span>
                                <div style={{ flex: 0.5 }}>
                                    <Field
                                        name="statusId"
                                        hintText="Select Status"
                                        component={renderAutoCompleteSingleSelect}
                                        options={this.props.masterData}
                                        handleNewRequest = {this.handleStatusChange}
                                        disabled ={this.state.disableStatus}
                                        // disabled={
                                        //     !this.props.addPermission 
                                        //     || !this.props.isDisabledField
                                        // }
                                    />
                                </div>
                            </div>
                        </div>

                    </div>}

                    <div className="row">
                        <div className="col-sm-6 mt-20"></div>
                        <div className="col-sm-6 pt20 btn_rt">
                            <CommonButton type="submit" className="ml_15" disabled={!this.props.isDisabledField} primary={true} label="Save" />
                        </div>
                    </div>
                </form>
            </div>
        )
    }
}

//const selector = formValueSelector('PatientMasterCriteriaForm');
const mapStateToProps = (state, ownProps) => {
    // Start For Role Permission
    let userActionPermission = [];
    if (state.login.userPermission) {
        let userModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === "CLIENT");
        let userScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.screenKey === "CLIENT_DATACOLLECTION_SETUP" && obj.moduleId === userModulePermission[0].moduleId);
        userActionPermission = state.login.userPermission.actionPermissions.filter((obj) => obj.screenId === userScreenPermission[0].screenId && obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);
    }

    let hasDefaultAccess = state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.userType === 'ADMIN' ? true : false; // For Role Permission

    let addPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === "CLIENT_DATACOLLECTION_SETUP_ADD_MASTERY_CRITERIA")[0].permission : false;

    let isDisabledField = hasDefaultAccess ? true : state.login.userPermission.actionPermissions ? state.login.userPermission.actionPermissions.find((obj) => {
        return obj.actionKey === "MASTERS_DATA_COLLECTION_DEFAULT_SETTINGS"
    }).permission : false;

    return {
        addPermission: addPermission,
        isDisabledField:isDisabledField,
        masterData: state.defaultSettingsReducer && state.defaultSettingsReducer.masterData && state.defaultSettingsReducer.masterData.targetStatusWithoutReady,
        loading: state.defaultSettingsReducer.loading,
        default_settings_data:state.defaultSettingsReducer && state.defaultSettingsReducer.default_settings_data && state.defaultSettingsReducer.default_settings_data.data
    };
};

DefaultSettings = reduxForm({
    form: 'DefaultSettingsForm',
    validate,
    enableReinitialize: true,
})(DefaultSettings);


export default connect(mapStateToProps, { getMasterData,SaveDefaultTargetSettingsData,getDefaultTargetSettingsData })(DefaultSettings);


// WEBPACK FOOTER //
// ./src/modules/MastersDataCollection/settings/defaultSettings/index.js